<template>
  <div>
    <Title
      title="智慧管理"
      subTitle="Intelligent Management"
      @showMore="showMore"
    ></Title>
    <!-- 数字 -->
    <div class="title-through">数字治理</div>
    <div class="count-con">
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">服务人员</div>
          <div class="count">
            <!-- <p>{{ manageData.serviceNum }}</p> -->
            <p>295</p>
            <span>人</span>
          </div>
        </div>
      </div>
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">服务次数</div>
          <div class="count">
            <p>{{ formatter(manageData.serviceTimes) }}</p>
            <span>次</span>
          </div>
        </div>
      </div>
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">人员配比</div>
          <div class="count">
            <!-- <p>{{ manageData.serviceRatio }}</p> -->
            <p>4.1</p>
            <span>: 1</span>
          </div>
        </div>
      </div>
      <div class="count-item">
        <div class="left-icon">
          <div></div>
        </div>
        <div class="content">
          <div class="title">智能设备</div>
          <div class="count">
            <p>{{ formatter(manageData.equipmentNum) }}</p>
            <span>台</span>
          </div>
        </div>
      </div>
    </div>
    <div class="title-through">老人结构</div>
    <div class="elder-num-con">
      <div class="left-con">
        <div class="left-item">
          <div class="title">老人数量</div>
          <div class="num">{{ manageData.elderNum }}</div>
        </div>
        <div class="left-item">
          <div class="title">男女比例</div>
          <div class="num">
            {{ manageData.elderManRatio }}/<span>{{
              manageData.elderWomanRatio
            }}</span>
          </div>
        </div>
      </div>
      <div class="right-con">
        <div class="chart-title">老人年龄分布</div>
        <div id="age-chart2"></div>
      </div>
    </div>
    <div class="title-through">院内防疫信息</div>
    <div id="throuth-fy"></div>
    <div class="title-through" style="margin-top: 10px">护理员管理</div>
    <div class="nurse-human-con">
      <div class="nurse-left-con">
        <div class="count-item">
          <div class="left-icon">
            <div></div>
          </div>
          <div class="content">
            <div class="title">护理员人数</div>
            <div class="count">
              <p>{{ manageData.nurseNum }}</p>
              <span>人</span>
            </div>
          </div>
        </div>
        <div class="count-item">
          <div class="left-icon">
            <div></div>
          </div>
          <div class="content">
            <div class="title">在岗人天数</div>
            <div class="count">
              <p>{{ manageData.nurseWork }}</p>
              <span>天</span>
            </div>
          </div>
        </div>
        <div class="count-item">
          <div class="left-icon">
            <div></div>
          </div>
          <div class="content">
            <div class="title">补贴金额</div>
            <div class="count">
              <p>{{ manageData.nurseMoneyCount || 0 }}</p>
              <span>元</span>
            </div>
          </div>
        </div>
        <div class="count-item">
          <div class="left-icon">
            <div></div>
          </div>
          <div class="content">
            <div class="title">培训次数</div>
            <div class="count">
              <p>{{ formatter(manageData.nurseTrainNum) }}</p>
              <span>次</span>
            </div>
          </div>
        </div>
      </div>
      <div class="nurse-right-con">
        <div class="chart-title">护理员技术水平比例</div>
        <div id="level-chart2"></div>
      </div>
    </div>
    <div class="display-con">
      <div class="display-item">
        <div class="title">服务管理</div>
        <div class="item">
          累计服务次数
          <span class="yellow">{{ formatter(manageData.serviceTimes) }}</span>
          次
        </div>
        <div class="item">
          照护计划完成率
          <span class="yellow">{{ manageData.takeCarePlanFin }}</span> %
        </div>
        <div class="item">
          安全评估人次
          <span class="yellow">{{ manageData.evaluateTimes }}</span> 次
        </div>
      </div>
      <div class="display-item">
        <div class="title">财务管理</div>
        <div class="item">
          累计月账单
          <span class="yellow">{{ formatter(manageData.monthBill) }}</span>
          元
        </div>
        <div class="item">
          累计捐赠物资
          <span class="yellow">{{ manageData.donateGoods }}</span> 件
        </div>
        <div class="item">
          累计捐赠资金
          <span class="yellow">{{ formatter(manageData.donateMoney) }}</span> 元
        </div>
      </div>
    </div>
    <div class="title-through">物资管理</div>
    <div class="goods-manage-con">
      <div id="goods-chart"></div>
      <div class="goods-right">
        <div class="item">
          总库存成本
          <span class="yellow">{{
            formatter(manageData.stockMoneyCount)
          }}</span>
          元
        </div>
        <div class="item">
          入库
          <span class="yellow">{{ formatter(manageData.stockIn) }}</span> 元
        </div>
        <div class="item">
          出库 <span class="yellow">{{ manageData.stockOut }}</span> 次
        </div>
      </div>
    </div>
    <div class="title-through">能耗管理</div>
    <div class="energy-con">
      <div class="energy-item">
        累计用水 <span class="yellow">1800</span> 吨
      </div>
      <div class="energy-item">
        累计用电 <span class="yellow">2200</span> 度
      </div>
    </div>
    <div id="energy-chart"></div>
    <div class="title-through">智能设备</div>
    <div class="devices-con">
      <Devices :deviceData="deviceData"></Devices>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Commen/CloseTitle";
import Devices from "./Devices"; // 设备监控
const echarts = require("echarts");
import roseChart from "./charts/rosePie";
import fyChart from "./charts/fyBar";
import energyChart from "./charts/energyLine";
import { mapState } from "vuex";
export default {
  components: {
    Title,
    Devices
  },
  computed: {
    ...mapState(["manageData"]),
  },
  data() {
    return {
      serviceNum: {
        number: [16],
        content: "{nt}",
      },
      age_data: [],
      staff_ym_arr: [], //员工疫苗
      goods_data: [],
      level_data: [], // 护理等级
      deviceData: [
        {
          name: "视频监控",
          icon: require("@/assets/security/spjk.png"),
          device: 77,
          rate: 98,
        },
        {
          name: "智能床垫",
          icon: require("@/assets/security/wcjc.png"),
          device: 1310,
          rate: 99,
        },
        {
          name: "跌倒监测",
          icon: require("@/assets/security/ddjc.png"),
          device: 1310,
          rate: 97,
        },
        {
          name: "呼叫器",
          icon: require("@/assets/security/jjhj.png"),
          device: 1310,
          rate: 98,
        },
        // {
        //   name: "照护手持机",
        //   icon: require("@/assets/security/zhscj.png"),
        //   device: 0,
        // },
        // {
        //   name: "智慧门岗",
        //   icon: require("@/assets/security/zhmg.png"),
        //   device: 0,
        // },
        // {
        //   name: "助餐设备",
        //   icon: require("@/assets/security/zcsb.png"),
        //   device: 0,
        // },
        // {
        //   name: "健康检测",
        //   icon: require("@/assets/security/jkjc.png"),
        //   device: 0,
        // },
        // {
        //   name: "生命探测",
        //   icon: require("@/assets/security/smtc.png"),
        //   device: 0,
        // },
        // {
        //   name: "安全巡防",
        //   icon: require("@/assets/security/aqxf.png"),
        //   device: 0,
        // },
      ],
    };
  },
  async created() {},
  async mounted() {
    await this.handelData();
    this.drawChart();
  },
  methods: {
    async handelData() {
      // 年龄分布
      const age_data = this.manageData.elderAgeMap;
      let age_arr = [];
      Object.keys(age_data).forEach((item) => {
        let obj = {};
        obj["name"] = item;
        obj["value"] = age_data[item];
        age_arr.push(obj);
      });
      this.age_data = age_arr;
      // 员工防疫信息
      const ymData = this.manageData.ymCountStaff;
      let staff_ym_arr = [];
      staff_ym_arr[0] = ymData["zero"];
      staff_ym_arr[1] = ymData["one"];
      staff_ym_arr[2] = ymData["two"];
      staff_ym_arr[3] = ymData["three"];
      this.staff_ym_arr = staff_ym_arr;
      // 物资管理
      this.goods_data = this.manageData.stockRatio.map((item) => {
        return {
          value: item.num,
          name: item.materialTypeName,
        };
      });
      this.level_data = this.manageData.caregiversLevelList.map((item) => {
        return {
          value: item.num,
          name: item.certificateName,
        };
      });
    },
    showMore() {
      this.$store.commit("setDrawer", true);
      this.$store.commit("setCurrentMenu", "manage");
    },
    drawChart() {
      // 老人年龄分布
      this.ageChart = echarts.init(document.getElementById("age-chart2"));
      this.ageChart.setOption(roseChart(this.age_data));
      // 护理等级分布
      this.levelChart = echarts.init(document.getElementById("level-chart2"));
      this.levelChart.setOption(roseChart(this.level_data));
      this.fyChart = echarts.init(document.getElementById("throuth-fy"));
      this.fyChart.setOption(fyChart(this.staff_ym_arr));
      // 物资管理
      this.goodsChart = echarts.init(document.getElementById("goods-chart"));
      this.goodsChart.setOption(roseChart(this.goods_data));
      this.energyChart = echarts.init(document.getElementById("energy-chart"));
      this.energyChart.setOption(energyChart());
    },
    formatter(number = 0) {
      number = Math.abs(number);
      console.log(number);
      return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
.count-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 450px;
  margin-top: 5px;
  .count-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left-icon {
    position: relative;
    width: 9px;
    height: 38px;
    transform: rotate(0deg);
    opacity: 1;
    pointer-events: none;
    border: 1px solid rgb(0, 139, 255);
    background-color: rgba(0, 58, 140, 0.1);
    border-radius: 8px;
    div {
      position: absolute;
      width: 7px;
      height: 22px;
      transform: rotate(0deg);
      opacity: 1;
      pointer-events: none;
      left: 1px;
      top: 15px;
      background-color: rgb(0, 255, 232);
      opacity: 1;
      border-radius: 8px;
    }
  }
  .content {
    display: flex;
    align-items: flex-start;
    justify-items: center;
    flex-direction: column;
    margin-left: 10px;
    .title {
      color: rgb(121, 218, 255);
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: normal;
      margin: 0px 0px 1.75px;
      justify-content: flex-start;
    }
    .count {
      display: flex;
      align-items: baseline;
      font-size: 27px;
      font-weight: bolder;
      letter-spacing: 0.02em;
      color: #fff;
      p {
        margin: 0;
      }
      span {
        color: #fff;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.74);
        font-weight: normal;
        vertical-align: super;
        font-family: Microsoft Yahei;
        margin-left: 2px;
      }
    }
  }
}
.charts-con {
  width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .chart-item {
    width: 50%;
    .chart-title {
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 16px;
      writing-mode: horizontal-tb;
      text-overflow: unset;
      white-space: unset;
      color: rgb(255, 255, 255);
    }
    // #age-chart2 {
    //   position: relative;
    //   z-index: 999;
    //   width: 200px;
    //   height: 200px;
    // }

    .chart-desc {
      color: rgb(222, 246, 255);
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 18px;
      span {
        font-size: 18px;
        color: rgb(238, 255, 5);
        font-family: DIN;
      }
    }
  }
}
.title-through {
  color: #fff;
  font-size: 14px;
}
.elder-num-con {
  width: 450px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .left-con {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
    .left-item {
      color: #fff;
      width: 50%;
      .title {
        font-size: 16px;
      }
      .num {
        font-size: 27px;
        font-weight: bolder;
        span {
          color: #fff;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.74);
          font-weight: normal;
          vertical-align: super;
          font-family: Microsoft Yahei;
          margin-left: 2px;
          vertical-align: baseline;
        }
      }
    }
  }
  .right-con {
    width: 50%;
    color: #fff;
    font-size: 16px;
    .chart-title {
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 14px;
      writing-mode: horizontal-tb;
      text-overflow: unset;
      white-space: unset;
      color: rgb(255, 255, 255);
    }
    #age-chart2 {
      position: relative;
      z-index: 999;
      width: 200px;
      height: 140px;
    }
  }
}
#throuth-fy {
  width: 400px;
  height: 100px;
}
.nurse-human-con {
  width: 450px;
  display: flex;
  justify-content: space-between;
}
.nurse-left-con {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 50%;
  flex-wrap: wrap;
  .count-item {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .left-icon {
    position: relative;
    width: 9px;
    height: 38px;
    transform: rotate(0deg);
    opacity: 1;
    pointer-events: none;
    border: 1px solid rgb(0, 139, 255);
    background-color: rgba(0, 58, 140, 0.1);
    border-radius: 8px;
    div {
      position: absolute;
      width: 7px;
      height: 22px;
      transform: rotate(0deg);
      opacity: 1;
      pointer-events: none;
      left: 1px;
      top: 15px;
      background-color: rgb(0, 255, 232);
      opacity: 1;
      border-radius: 8px;
    }
  }
  .content {
    display: flex;
    align-items: flex-start;
    justify-items: center;
    flex-direction: column;
    margin-left: 10px;
    .title {
      color: rgb(121, 218, 255);
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: normal;
      margin: 0px 0px 1.75px;
      justify-content: flex-start;
    }
    .count {
      display: flex;
      align-items: baseline;
      font-size: 22px;
      font-weight: bolder;
      letter-spacing: 0.02em;
      color: #fff;
      p {
        margin: 0;
      }
      span {
        color: #fff;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.74);
        font-weight: normal;
        vertical-align: super;
        font-family: Microsoft Yahei;
        margin-left: 2px;
      }
    }
  }
}
.nurse-right-con {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  .chart-title {
    font-weight: normal;
    font-family: "Microsoft Yahei", Arial, "sans-serif";
    font-size: 14px;
    writing-mode: horizontal-tb;
    text-overflow: unset;
    white-space: unset;
    color: rgb(255, 255, 255);
  }
  #level-chart2 {
    position: relative;
    z-index: 999;
    width: 150px;
    height: 150px;
  }
}
.display-con {
  width: 450px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: #fff;
  .display-item {
    .title {
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 16px;
      margin-bottom: 5px;
    }
    .item {
      font-size: 12px;
      .yellow {
        color: rgb(238, 255, 5);
        font-size: 16px;
      }
    }
  }
  .display-item:last-child {
    margin-right: 30px;
  }
}
.goods-manage-con {
  width: 450px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  #goods-chart {
    width: 200px;
    height: 100px;
  }
  .goods-right {
    color: #fff;
    margin-right: 30px;
    .title {
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 16px;
      margin-bottom: 5px;
    }
    .item {
      font-size: 12px;
      .yellow {
        color: rgb(238, 255, 5);
        font-size: 16px;
      }
    }
  }
}
.energy-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 400px;
  color: #fff;
  font-size: 12px;
  font-family: "Microsoft Yahei", Arial, "sans-serif";
  margin-bottom: 5px;
  .yellow {
    color: rgb(238, 255, 5);
    font-size: 16px;
  }
}
#energy-chart {
  width: 400px;
  height: 150px;
}
</style>
